export default __webpack_public_path__ + "static/media/goog-2.6b37cfc9.jfif";